(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mlir-home"] && !Shopify.designMode) return;
  try {
    
function initializeMlirSets(scope = document) {
  scope.querySelectorAll('.mlir-set-builder').forEach((form) => {
    if (form.dataset.initialized) return;
    form.dataset.initialized = 'true';
    const data = JSON.parse(form.querySelector('[data-mlir-variants]').textContent);
    const color = form.elements.matching_color;
    const style = form.elements.bottom_style;
    const top = form.elements.top_size;
    const bottom = form.elements.bottom_size;
    const button = form.querySelector('button[type="submit"]');
    const status = form.querySelector('[role="status"]');
    const bottoms = () => data[style ? style.value : 'pants'];
    const populate = (select, variants) => {
      const previous = select.value;
      select.replaceChildren(new Option(form.dataset.placeholder, ''));
      variants.filter((v) => v.option1 === color.value && v.available).forEach((v) => {
        select.add(new Option(v.option2, String(v.id)));
      });
      if (Array.from(select.options).some((o) => o.value === previous)) select.value = previous;
      select.disabled = !color.value || select.options.length === 1;
    };
    const refresh = () => {
      populate(top, data.top);
      populate(bottom, bottoms());
      button.disabled = !top.value || !bottom.value;
      status.textContent = '';
    };
    Array.from(color.options).forEach((option) => {
      if (!option.value) return;
      const exists = (variants) => variants.some((v) => v.option1 === option.value && v.available);
      option.disabled = !exists(data.top) || !exists(bottoms());
    });
    color.addEventListener('change', refresh);
    if (style) style.addEventListener('change', refresh);
    [top, bottom].forEach((select) => select.addEventListener('change', () => {
      button.disabled = !top.value || !bottom.value;
      status.textContent = '';
    }));
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (form.dataset.busy === 'true' || !top.value || !bottom.value) return;
      const topVariant = data.top.find((v) => String(v.id) === top.value && v.option1 === color.value && v.available);
      const bottomVariant = bottoms().find((v) => String(v.id) === bottom.value && v.option1 === color.value && v.available);
      if (!topVariant || !bottomVariant) { refresh(); return; }
      const busyLabel = form.dataset.busy;
      form.dataset.busy = 'true';
      button.disabled = true;
      button.textContent = busyLabel;
      status.textContent = busyLabel;
      try {
        const response = await fetch(form.dataset.addUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: topVariant.id, quantity: 1 }, { id: bottomVariant.id, quantity: 1 }] })
        });
        if (!response.ok) throw new Error('cart-add');
        await response.json();
        window.location.assign(form.dataset.cartUrl);
      } catch (error) {
        status.textContent = form.dataset.error;
        form.dataset.busy = busyLabel;
        button.disabled = false;
        button.textContent = form.dataset.label;
      }
    });
  });
}
initializeMlirSets();
document.addEventListener('shopify:section:load', (event) => initializeMlirSets(event.target));


  } catch(e) { console.error(e); }
})();
})();
